/**
 * @generated SignedSource<<8eb6d3001b74da5474d8f6daddf86632>>
 * @relayHash 88ce082f1221677e0ad725068a26cd2a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c35b6e854d8d038957a805cd84df8ee5819909acacf17e50e84ea1d0ea413adf

import type { ConcreteRequest } from 'relay-runtime';
export type ContainerType = "BLOGPOST" | "DATABASE" | "PAGE" | "SPACE" | "WHITEBOARD" | "%future added value";
export type GraphQLReactionContentType = "BLOGPOST" | "COMMENT" | "PAGE" | "%future added value";
export type ConfluenceReactedUsersInput = {
  containerId?: string | null;
  containerType?: ContainerType | null;
  contentId: string;
  contentType: GraphQLReactionContentType;
  emojiId: string;
};
export type ReactedActorsQuery$variables = {
  cloudId: string;
  input: ConfluenceReactedUsersInput;
};
export type ReactedActorsQuery$data = {
  readonly confluence_reactedActors: {
    readonly actors: ReadonlyArray<{
      readonly agentId: string | null;
      readonly agentType: string | null;
      readonly person: {
        readonly accountId: string | null;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
      };
    } | null>;
    readonly count: number;
    readonly emojiId: string;
    readonly reacted: boolean;
    readonly success: boolean;
  } | null;
};
export type ReactedActorsQuery = {
  response: ReactedActorsQuery$data;
  variables: ReactedActorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceReactedActorsResponsePayload",
    "kind": "LinkedField",
    "name": "confluence_reactedActors",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceReactionActor",
        "kind": "LinkedField",
        "name": "actors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "agentId"
          },
          {
            "kind": "ScalarField",
            "name": "agentType"
          },
          {
            "concreteType": "ConfluencePerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "accountId"
              },
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "profilePicture",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "path"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "emojiId"
      },
      {
        "kind": "ScalarField",
        "name": "count"
      },
      {
        "kind": "ScalarField",
        "name": "reacted"
      },
      {
        "kind": "ScalarField",
        "name": "success"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ReactedActorsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReactedActorsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "88ce082f1221677e0ad725068a26cd2a",
    "id": "c35b6e854d8d038957a805cd84df8ee5819909acacf17e50e84ea1d0ea413adf",
    "metadata": {},
    "name": "ReactedActorsQuery",
    "operationKind": "query",
    "text": "query ReactedActorsQuery($cloudId:ID!,$input:ConfluenceReactedUsersInput!){confluence_reactedActors(cloudId:$cloudId,input:$input){actors{agentId,agentType,person{accountId,displayName,profilePicture{path}}},emojiId,count,reacted,success}}"
  }
};
})();

(node as any).hash = "73a5148519aac5bdc2d6ff3069187f23";

export default node;
